webpackJsonp([16],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(62);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _manual = __webpack_require__(264);
	
	var _manual2 = _interopRequireDefault(_manual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	new _vue2.default({
	  el: '#app',
	  template: '<manual/>',
	  components: { manual: _manual2.default }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var apiLinks = void 0;
	
	var yc = window.location.protocol + '//' + window.location.host;
	var enterpriseId = 146848;
	var tenantid = 'diyw5x9a';
	
	var slogan = '四川广安爱众股份有限公司';
	var logourl = 'static/imgs/logo.png';
	
	var companyname = '四川广安爱众股份有限公司';
	var companyfullname = '四川广安爱众股份有限公司';
	
	var companyHomePage = 'http://www.sc-aaa.com';
	
	var companyContactUs = 'http://www.aotecar.com/contact/&columnsId=55&FrontColumns_navigation01-1404201334910345678FirstColumnId=55.html';
	
	var portaltype = 'gaaz';
	
	var bannerList = [{
	  class: 'carousel-bg-jsqp2'
	}];
	
	var telephone = '0826-2983170';
	var address = '四川省广安市广安区渠江北路86号';
	var servicetime = '';
	
	exports.apiLinks = apiLinks = {
	  logourl: logourl,
	  address: address,
	  companyfullname: companyfullname,
	  telephone: telephone,
	  servicetime: servicetime,
	  companyname: companyname,
	  context: portaltype,
	  bannerList: bannerList,
	  slogan: slogan,
	  companyContactUs: companyContactUs,
	  selfHome: companyHomePage,
	  welcome: '您好，欢迎来到' + companyname + '采购门户！',
	  portaltype: portaltype,
	
	  materiaClass: yc + '/yuncai/jsonp/getMaterialClass?enterpriseId=' + enterpriseId + '&parentId=',
	  orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
	  southCement: {
	    home: companyHomePage
	  },
	  caslogout: '/yuncai/caslogout',
	
	  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=' + portaltype,
	
	  enterWorkbench: yc + '/workbench/sso/login.jsp',
	
	  suppliersFor: yc + "/cpu-portal-fe/portalcas.html#/pages/supplymgr/addSupplyApply?purentid=" + enterpriseId + "&ipuid=" + portaltype + "&v=" + Date.parse(new Date().toLocaleDateString()),
	
	  infoTable: {
	    latest: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'latest2', 'latest3'],
	    area: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', 'area2', 'area3', 'area4', 'area5', 'area6', 'area7', 'area8'],
	    type: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6', '2', '3', '4']
	  },
	
	  purchasetableDate: [yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=10&pageSize=10&pageIndex=0', '', ''],
	
	  logisticstableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0', '', ''],
	
	  logisticsestableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11,23&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'],
	
	  engineeringtableDate: ['', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12,24&pageSize=10&pageIndex=0', yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'],
	
	  details: {
	    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
	    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
	
	    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
	    biddocDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowbiddoc/index.html?show=1&id=',
	
	    xbj_bidNotice: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
	    ztb_bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
	    hxr_bidNotice: yc + '/cpu-fe-bid/dist/submitbidnoticehxr/index.html?type=3&projectId=',
	    jp_bidNotice: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
	
	    bidauctionNotice: yc + '/cpu-bidauction-fe/bidding_Apply/index.zh_CN.html?id=',
	    lbNotice: yc + '/cpu-fe-bid/dist/lbnotice/index.html?id=',
	    cqNotice: yc + '/cpu-fe-bid/dist/clarifynotice/index.html?id=',
	    changeNotice: yc + '/cpu-fe-bid/dist/newclarify/page_show4public/index.html?&id=',
	
	    company: yc + '/gwmanage/pages/notice/detail.html?id=',
	    noticeMore: yc + '/cpu-dashboard-fe/index.html#/anoucementlist?tenantid=' + tenantid,
	    lbnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=18',
	    cqnoticeMore: yc + '/cpu-dashboard-fe/index.html#/noticelist?supEnterpriseId=' + enterpriseId + '&status=19'
	  },
	  notice: {
	    company: '/gwmanage/pub/notice/entnotice?tenantid=' + tenantid + '&pageIndex=1&pageSize=6&key=',
	    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=6&pageIndex=0',
	    clarify: '',
	    lbnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=18&pageIndex=0&pageSize=6',
	    cqnotice: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=19,25&pageIndex=0&pageSize=6'
	  },
	
	  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
	
	  agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
	};
	exports.apiLinks = apiLinks;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  name: 'gheader',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      southCement: _links.apiLinks.southCement['home'],
	      enterWorkbench: _links.apiLinks.enterWorkbench,
	      caslogout: _links.apiLinks.caslogout,
	      apiLinks: _links.apiLinks
	    };
	  }
	};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  data: function data() {
	    return {
	      slogan: _links.apiLinks.slogan,
	      logourl: _links.apiLinks.logourl
	    };
	  }
	};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _links = __webpack_require__(2);
	
	exports.default = {
	  name: 'grednav',
	  props: {
	    type: ''
	  },
	  data: function data() {
	    return {
	      apiLinks: _links.apiLinks
	    };
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(18)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(12),
	  /* template */
	  __webpack_require__(24),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(16)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(13),
	  /* template */
	  __webpack_require__(22),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(17)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(23),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-logo"
	  }, [_c('div', {
	    staticClass: "main-width set-position"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.logourl,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "inline-block",
	      "position": "relative",
	      "top": "10px",
	      "font-size": "18px"
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.slogan) + "\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "apps"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/wechat.jpg",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("友云采公众号")]), _vm._v(" "), _c('img', {
	    staticClass: "hideimg",
	    attrs: {
	      "src": "static/imgs/supplier.png",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "hideimg"
	  }, [_vm._v("供应商App")]), _vm._v(" "), _c('img', {
	    staticClass: "hideimg",
	    attrs: {
	      "src": "static/imgs/purchaser.png",
	      "alt": "",
	      "width": "70px"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "hideimg"
	  }, [_vm._v("采购商App")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group pull-right hidden"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "搜索商机/物资"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/search.png"
	    }
	  })])])])
	}]}

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-red-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('ul', {
	    staticClass: "list-basic-settings",
	    attrs: {
	      "id": "red-nav-navbar"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "purchase.html"
	    }
	  }, [_vm._v("招采信息")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "logistics.html"
	    }
	  }, [_vm._v("物流招标")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "logisticses.html"
	    }
	  }, [_vm._v("工程招标")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "href": "service.html"
	    }
	  }, [_vm._v("服务招标")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-red-nav-a",
	    attrs: {
	      "target": "_blank",
	      "href": "contact.html"
	    }
	  }, [_vm._v("联系我们")])])
	}]}

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row-nav"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "row-nav-navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "list-basic-settings pull-right"
	  }, [(_vm.type == 'home') ? [_vm._m(0)] : [_vm._m(1)], _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.enterWorkbench
	    }
	  }, [_vm._v("工作中心")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "home-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")])]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.apiLinks.selfHome,
	      "target": "_blank"
	    }
	  }, [_vm._v("返回官网")]), _vm._v("  |  ")]), _vm._v(" "), _c('li', {
	    staticClass: "cashome-li-a"
	  }, [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": _vm.caslogout
	    }
	  }, [_vm._v("退出")])])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "home.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "row-nav-a",
	    attrs: {
	      "href": "cashome.html"
	    }
	  }, [_vm._v("首页")]), _vm._v("   |  ")])
	}]}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GHeader = __webpack_require__(19);
	
	var _GHeader2 = _interopRequireDefault(_GHeader);
	
	var _GLogo = __webpack_require__(20);
	
	var _GLogo2 = _interopRequireDefault(_GLogo);
	
	var _GRednav = __webpack_require__(21);
	
	var _GRednav2 = _interopRequireDefault(_GRednav);
	
	var _links = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    gheader: _GHeader2.default,
	    glogo: _GLogo2.default,
	    grednav: _GRednav2.default
	  },
	  data: function data() {
	    return {
	      companyName: _links.apiLinks.companyname,
	      context: _links.apiLinks.context
	    };
	  },
	
	  methods: {
	    enterlink: function enterlink() {
	      var str = window.location.href;
	      var array = str.split('?');
	      if (array[1] === 'register') {
	        window.location.href = _links.apiLinks.register;
	      } else if (array[1] === 'applyFor') {
	        window.location.href = _links.apiLinks.suppliersFor;
	      }
	    }
	  }
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(244)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(209),
	  /* template */
	  __webpack_require__(284),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('gheader', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
	    attrs: {
	      "type": "home"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-agreement"
	  }, [_c('div', {
	    staticClass: "main-width"
	  }, [_c('div', {
	    attrs: {
	      "id": "agreement"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('h4', [_vm._v("一、供应商须知")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("尊敬的供应商：")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("您好！")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("目前" + _vm._s(_vm.companyName) + "采购门户已经上线了网上招标采购系统，未来我们会把更多的采购信息都发布到系统中，期待您注册网上招采平台和我们长期合作。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。")]), _vm._v(" "), _c('h4', [_vm._v("二、供应商申请流程")]), _vm._v(" "), _c('h5', [_vm._v("1.网上招采地址")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("请在浏览器中输入地址https://yc.yonyoucloud.com/" + _vm._s(_vm.context) + " 登陆" + _vm._s(_vm.companyName) + "采购门户。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("2.供应商注册")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("希望参加" + _vm._s(_vm.companyName) + "采购招标的供应商需要在网上申请成为" + _vm._s(_vm.companyName) + "的供应商。")]), _vm._v(" "), _c('h6', [_vm._v("2.1 开始注册")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("点击“供应商注册”按钮开始注册。")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h6', [_vm._v("2.2 确认相关条款")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("同意并继续后开始填写相关资料")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h6', [_vm._v("2.3 填写账号信息")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("手机号：需要用手机号进行注册（一个手机号只能注册一个账号）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("账号：即登录采购门户进行报名，投标等操作的账号（账号必须是唯一的无法重复）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("密码：账户的密码")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("企业名称：请确认是公司全称，注册后无法修改。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h6', [_vm._v("2.4 完善供应商信息")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("完善供应商注册信息有两种方式，一种是继续完善供应商资料，另一种时登录账号继续完善相关资料。（两种方式选择一种即可）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商名称：由上一步代入")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("管理组织：即确定您提交的资料由哪一家公司审核。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件账号。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应品类：即您要申请的供货类别（请如实填写）")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("2.4.1 继续完善资料")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("相关资料填写完成后点击“提交采购商审核即可”。")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("2.4.2 登录账号完善资料。")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("2.4.2.1 返回采购门户，点击按钮“立即登录”。输入“账号”“密码”后登录。")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("2.4.2.2 登录后点击“供应商申请”按钮填写供应商相关资料。")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("\n            同意相关条款后，直接到供应商资料填写页面，填写完相关资料后，提交采购商审核即可\n          ")]), _vm._v(" "), _c('h5', [_vm._v("三、查看供应商审核是否通过")]), _vm._v(" "), _c('h6', [_vm._v("3.1 账号登录")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("登录供应商账号，登录后点击进入工作台。")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h6', [_vm._v("3.2 查看供应商申请界面")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h6', [_vm._v("3.3 查看审核是否通过")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以参加" + _vm._s(_vm.companyName) + "相关企业的采购招标。")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h4', [_vm._v("三、供应商招标")]), _vm._v(" "), _c('h5', [_vm._v("1.供应商报名")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商报名分两种情况，一种是邀请报名，一种是直接报名。")]), _vm._v(" "), _c('h6', [_vm._v("1.1 邀请报名")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h6', [_vm._v("1.2 直接报名")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("在" + _vm._s(_vm.companyName) + "招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h5', [_vm._v("2.供应商招标")]), _vm._v(" "), _c('h6', [_vm._v("2.1 供应商投标")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("\n            登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h5', [_vm._v("3.中标通知")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("中标后供应商账号和招标门户都会收到中标通知。")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('h4', [_vm._v("四、供应商上架商品到采购商云采超市")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商要将自己的商品上架到采购商的云采超市里，可以通过两种方式进行。一种是通过发送“允销申请”，一种是通过与采购商已发生的销售合同发布合同商品清单。")]), _vm._v(" "), _c('h5', [_vm._v("1.发送“允销申请”")]), _vm._v(" "), _c('h6', [_vm._v("1.1维护“商品分类”")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("添加商品前先添加商品分类，后续再进行商品管理时进行对应。")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('h6', [_vm._v("1.2维护“商品管理”")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("将自己要进行上架的商品在“商品管理”进行维护。")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("完善维护好商品信息后进行发布。")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("将新添加的商品进行上架，这里的“上架”是指供应商将商品的状态变为“销售中”。")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('h6', [_vm._v("1.3发送“允销申请”")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商将自己销售状态的商品通过“允销申请”发送给采购商，采购商通过此申请后可将对应的商品上架到采购商的云采超市，方便采购商直接通过超市下单商品。")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("维护允销申请信息。")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("提交发送“允销申请”。")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("申请提交后，状态会到“待确认”；采购商确认后，状态会到“已确认”；采购商驳回后，状态会到“被驳回”，驳回后的申请可进行修改后再提交。")]), _vm._v(" "), _c('h5', [_vm._v("2.发送“合同商品清单”")]), _vm._v(" "), _c('h6', [_vm._v("2.1发布商品清单")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("供应商将已确认已生效的销售合同在“查看详情”里点击“商品清单管理”，然后进行“发布商品清单”。")]), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('h6', [_vm._v("2.2查看清单状态")]), _vm._v(" "), _c('p', {
	    staticClass: "text-padding"
	  }, [_vm._v("发布后，可在“合同管理-合同清单管理”查看状态，“待提交”指还未发布商品清单给采购商，当前只是一个保存状态；“已提交”指已将清单发布给采购商，当前采购商还未确认；“已确认”指采购商已将此清单进行确认，当前清单里的商品已获得采购商同意上架到采购商的云采超市。")]), _vm._v(" "), _vm._m(30)])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "source"
	    }
	  }, [_c('p')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_1.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_2.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual4.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual5.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_3.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_9.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_3.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_5.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual10.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual11.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual12.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_6.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual14.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_7.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual16.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual17.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual18.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual19.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual20.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_8.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_21.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_22.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_23.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_24.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_25.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_26.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_27.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_28.png",
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "manual-img"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/imgs/manual_29.png",
	      "alt": ""
	    }
	  })])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/api/manual.a0a0491bd0ad6d3427ae.js